<template>
    <div>
        <overview
            v-if="!globalLoading"
            :name="name"
            :dataoverview="dataoverview"
            :mappingName="mappingName"
            :overviewClass="overviewClass"
            :nav="customNavMap"
            :moreNav="moreNav"
            :contextId="contextId"
        >
        </overview>
    </div>
</template>

<script>
import Overview from 'vcomponents/overview/Overview.vue';
import OverviewThirdModule from '../../store/overview/overviewThird';
import OverviewMixin from '../overview/OverviewMixin';

import SellsyAdminSamOverviewMixin from '../../mixins/sellsyaccountmanager/SellsyAdminSamOverviewMixins';

import Feature from 'Services/Feature';

import { createNamespacedHelpers } from 'vuex';
const { mapState, mapActions } = createNamespacedHelpers('system');
const popupPanelMapActions = createNamespacedHelpers('popupPanel').mapActions;

export default {
    components: {
        Overview,
    },
    mixins: [OverviewMixin, SellsyAdminSamOverviewMixin],
    data() {
        return {
            module: OverviewThirdModule, // à récupérer du router
            isLoading: false,
        };
    },
    computed: {
        ...mapState({
            globalLoading: 'globalLoading',
        }),
        customNavMap() {
            if (
                this.$store.getters?.identity?.type === 'client' &&
                this.$store.getters?.identity?.isCorporation &&
                Feature.isEnabled('sellsy-ai') &&
                !this.navMap
                    .find((item) => item.id === 'informations')
                    .items.find((item) => item.id === 'summary')
            ) {
                this.navMap
                    .find((item) => item.id === 'informations')
                    .items.splice(1, 0, {
                        id: 'summary',
                        databot: 'client-overview__menu--summary',
                        label: this.$t.__('overview.tabs.TabSummary'),
                        group: false,
                        component: 'tab-summary-third',
                        icon: 'ai-sparkles-simple',
                        more: {},
                    });
            }

            return this.navMap;
        },
    },
    created() {
        this.init(this.$route.params.id);
    },
    beforeDestroy() {
        this.$storeHasModule('third') ? this.$store.unregisterModule('third') : null;
    },
    methods: {
        ...mapActions(['toggleLoading']),
        ...popupPanelMapActions(['open']),
        init(id) {
            this.moreNav = [];
            this.navMap = [];

            this.toggleLoading();
            this.overviewClass
                .fetch(id)
                .then((response) => {
                    this.initStore(response).then(() => {
                        this.navMap = this.overviewClass.getNav();

                        if (
                            response.dataoverview.data.sellsyadmin &&
                            response.dataoverview.data.sellsyadmin.enabled
                        ) {
                            this.moreNav = _.cloneDeep(this.overviewClass.getMoreNav());
                            this.setSamNavMap(
                                this.overviewClass.getSellsyAdminCommonTabs(),
                                this.overviewClass.getSamTabs(),
                            );
                            this.moreNav = this.setMoreNav(this.moreNav);
                        }

                        this.navMap = this.buildNav(this.navMap);

                        this.setDataoverview();
                        this.dispatchData();
                        this.toggleLoading();

                        if (this.urlParams.has('createOpportunity')) {
                            this.openOpportunity();
                        }
                        if (this.urlParams.has('invoicing_createestimate')) {
                            this.createEstimate();
                        }
                    });
                })
                .catch(() => {
                    Push.error(this.$l10n.__("Vous n'avez pas les droits nécessaires"));
                    this.toggleLoading();
                    this.$router.push({ name: this.$route.params.type });
                });
        },
        openOpportunity() {
            this.open({
                key: 'opportunityForm',
                props: {
                    oppId: false,
                    mode: 'edit',
                    action: 'edit',
                    linkedid: parseInt(this.$route.params.id),
                    linkedtype: 'third',
                    emitAddSuccess: 'listing:refresh',
                },
            });
        },
        createEstimate() {
            DocTools.createForThird(
                'estimate',
                'Créer un devis',
                true,
                null,
                this.$route.params.id,
            );
        },
    },
};
</script>
